import React from 'react';
import _ from 'lodash';
import { elementTypes, elementIds } from 'crazyEditor/components/Elements/index';
import { getElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {note, text, shapePlus} from 'shared/icons/index';
import HelpIcon from 'material-ui/svg-icons/action/help';
import * as Colors from 'material-ui/styles/colors';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import { EDITOR_STAGE_ID } from 'crazyEditor/core/constants/editorConstants';


export const HelpIconWithToolTip = props => {
  const {tooltip, style} = props;
  return (<TooltipWrapper
    popoverType="grey"
    tooltip = {tooltip}
    tooltipStyle = {{padding: 10}}
    style={{display: 'inline', paddingRight: 10, position: 'relative', ...style}}
    leaveDelay={0}
    anchorOrigin = {{horizontal: 'middle', vertical: 'bottom'}}
    targetOrigin = {{horizontal: 'left', vertical: 'top'}}
  >
    <span><HelpIcon style={{width: 20, height: 20, verticalAlign: 'middle'}} color={Colors.grey300}/></span>
    {
      // there is seems to be a bug where hovering svg will trigger unwanted mouse out event for the tooltip wrapper.
    }
    <div style={{position: 'absolute', width: '100%', height: '100%', left: 0, top: 0}}/>
  </TooltipWrapper>);
};

const SubHeaderWithTooltip = (props) => {
  const {tooltip, subheader} = props;
  return (
    <span>
        <span>{subheader} </span>
        <HelpIconWithToolTip tooltip={tooltip}/>
      </span>
  );
};

export function getMenuElementsTree({setSelectedElementIds, templateTagSpecifics}) {
  const menuElements = {
    page: {
      label: 'Page',
      icon: note,
      nestedMenuElements: [
        {selectOnly: true, elementType: elementTypes.PageElement, onClick: () => setSelectedElementIds(elementIds.PageElement)},
        {selectOnly: true, elementType: elementTypes.BackgroundElement, onClick: () => setSelectedElementIds(elementIds.BackgroundElement)},
      ]
    },
    text: {
      label: 'Text',
      icon: text,
      nestedMenuElements: [
        {subheader: <SubHeaderWithTooltip tooltip = "These texts are bind to the design and will not change according to product's content. They will look exactly the same on all listings." subheader = "additional texts"/>},
        {noIcon: true, elementType: elementTypes.TitleElement},
        {noIcon: true, elementType: elementTypes.RichTextElement},
      ]
    },
    elements: {
      label: 'Elements',
      icon: shapePlus,
      nestedMenuElements: [
        {elementType: elementTypes.GalleryElement},
        {elementType: elementTypes.ImageElement},
        {elementType: elementTypes.IconElement},
        {elementType: elementTypes.VideoElement},
        {elementType: elementTypes.ShapeElement},
        {elementType: elementTypes.HtmlElement},
        {elementType: elementTypes.TabsElement},
        {elementType: elementTypes.CrossSellGalleryElement},
      ]
    }
  };
  _.forEach(menuElements, menuElement => {
    _.forEach(menuElement.nestedMenuElements, nestedMenuElement => {
      const {elementType, selectOnly} = nestedMenuElement;
      if (elementType && !selectOnly) {
        nestedMenuElement.elementPreset = getElementPreset(elementType);
      }
    });
  });
  if (!_.isEmpty(templateTagSpecifics)) {
    menuElements.text.nestedMenuElements = [
      {subheader: <SubHeaderWithTooltip tooltip = "These texts are your product's content." subheader = "product"/>},
      ..._.map(_.sortBy(_.filter(templateTagSpecifics, 'displayName'), 'order'), templateTag => {
        return {
          templateTag,
          label: templateTag.displayName,
          elementType: elementTypes.TitleElement,
          elementPreset: _.merge({data: {templateTag: templateTag.name}}, getElementPreset(elementTypes.TitleElement), templateTag.preset, {data: {text: templateTag.draftPlaceholder}}),
          noIcon: true,
        };
      }),
      ...menuElements.text.nestedMenuElements
    ];
  }
  return menuElements;
}
